export const logger = {
  log () {
    if (!process.env.CI) {
      console.log(...arguments)
    }
  }
}
